export const QUANTITY = 25
